import { MaterialProductValueType, SiteMaterialDetail, SiteMaterialList } from 'api';
import { UseFormSetValue } from 'form';

import { convertMaterialProductComponentAPIToMaterialComponentField } from '../../../material-products/utils/convertMaterialProductComponentAPIToMaterialComponentField/convertMaterialProductComponentAPIToMaterialComponentField';
import { BaseSalesOrderFormValues } from '../../types';

export const updateMaterialProperties = (
  siteMaterialDetail: SiteMaterialDetail | SiteMaterialList,
  setValue: UseFormSetValue<BaseSalesOrderFormValues>
) => {
  if (siteMaterialDetail?.material_product?.material_spec?.id) {
    setValue('material_spec_id', siteMaterialDetail?.material_product?.material_spec.id);
    setValue('material_id', siteMaterialDetail?.material_product?.material_spec.material.id);
    setValue('material_colour_id', siteMaterialDetail?.material_product?.material_spec.colour?.id);
  } else {
    setValue('material_id', siteMaterialDetail?.material_spec.material.id);
    setValue('material_colour_id', siteMaterialDetail?.material_spec.colour?.id);
  }
  if (siteMaterialDetail?.material_product?.material_grade?.id) {
    setValue('grade_id', siteMaterialDetail?.material_product?.material_grade.id);
  }
  setValue('origin_id', siteMaterialDetail?.material_product?.material_origin?.id);
  if (typeof siteMaterialDetail?.material_product?.is_food_grade === 'boolean') {
    setValue('is_food_grade', siteMaterialDetail?.material_product?.is_food_grade);
  }

  if (siteMaterialDetail?.material_product?.has_caps_and_labels !== null) {
    setValue('has_caps_and_labels', siteMaterialDetail?.material_product?.has_caps_and_labels);
  } else {
    setValue('has_caps_and_labels', undefined);
  }

  if (siteMaterialDetail?.material_product?.material_component_values) {
    const buyerMaterialComponentValues = convertMaterialProductComponentAPIToMaterialComponentField(
      siteMaterialDetail.material_product?.material_component_values,
      MaterialProductValueType.BUYER
    );
    setValue('buyer_material_component_values', buyerMaterialComponentValues);
    const sellerMaterialComponentValues = convertMaterialProductComponentAPIToMaterialComponentField(
      siteMaterialDetail.material_product?.material_component_values,
      MaterialProductValueType.SELLER
    );
    setValue('seller_material_component_values', sellerMaterialComponentValues);
  } else {
    setValue('buyer_material_component_values', []);
    setValue('seller_material_component_values', []);
  }
};
